import { z } from 'zod';
export const BranchSchema = z.object({
    id: z.uuid(),
    companyId: z.uuid(),
    code: z.string().min(1).max(32),
    nameTh: z.string().min(1),
    // 5-digit Thai tax-branch code; '00000' = head office. Optional — most branches
    // carry no tax-branch number until assigned (enforced as 5 digits when present).
    taxBranch: z
        .string()
        .regex(/^\d{5}$/)
        .nullable()
        .optional(),
    address: z.string().nullable().optional(),
    isActive: z.boolean(),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
});
export const CreateBranchSchema = BranchSchema.omit({
    id: true,
    createdAt: true,
    updatedAt: true,
});
// Branches cannot be moved between companies; companyId is immutable on update.
export const UpdateBranchSchema = CreateBranchSchema.partial().omit({
    companyId: true,
});
//# sourceMappingURL=branch.js.map